import { apiRequest } from "../index";

export const getReferralSettings = async () => {
  return apiRequest(`/api/admin/referral/settings`, "GET");
};

export const updateReferralSettings = async (data) => {
  return apiRequest(`/api/admin/referral/settings`, "PUT", data);
};

export const getReferralStatistics = async () => {
  return apiRequest(`/api/admin/referral/statistics`, "GET");
};

export const getTopReferrers = async ({ page = 1, limit = 10 }) => {
  return apiRequest(`/api/admin/referral/top-referrers?page=${page}&limit=${limit}`, "GET");
};

export const getActiveReferrals = async ({ page = 1, limit = 10 }) => {
  return apiRequest(`/api/admin/referral/active-referrals?page=${page}&limit=${limit}`, "GET");
};

export const payReferralAmount = async (data) => {
  return apiRequest(`/api/admin/referral/pay`, "POST", data);
};

export const getReferralSettingsHistory = async ({ page = 1, limit = 10 }) => {
  return apiRequest(`/api/admin/referral/settings/history?page=${page}&limit=${limit}`, "GET");
};

